import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["gradersRequired", "adjudicationField", "adjudicationCheckbox"]

  connect() {
    this.boundSync = () => this.syncAdjudicationVisibility()
    this.gradersRequiredTarget.addEventListener("input", this.boundSync)
    this.gradersRequiredTarget.addEventListener("change", this.boundSync)
    this.syncAdjudicationVisibility()
  }

  disconnect() {
    this.gradersRequiredTarget.removeEventListener("input", this.boundSync)
    this.gradersRequiredTarget.removeEventListener("change", this.boundSync)
  }

  syncAdjudicationVisibility() {
    const count = parseInt(this.gradersRequiredTarget.value, 10) || 1
    const dualGrading = count >= 2

    this.adjudicationFieldTarget.classList.toggle("hidden", !dualGrading)

    if (!dualGrading && this.hasAdjudicationCheckboxTarget) {
      this.adjudicationCheckboxTarget.checked = false
    }
  }
}
